import type { GeoDataCountry } from "@app/types/geo-data";

import type { Middleware } from "redux";

export const BB = window.BB;
export const GEO_DATA: GeoDataCountry[] | undefined = window.__GEO_DATA__;
export const PROPS = Object.assign({}, window.__PROPS__, {
  __GEO_DATA__: GEO_DATA
});
export const middlewares: Middleware[] = [];
